import { render } from "./WorkOrderBanner.vue?vue&type=template&id=5940825b&scoped=true"
import script from "./WorkOrderBanner.vue?vue&type=script&lang=js"
export * from "./WorkOrderBanner.vue?vue&type=script&lang=js"

import "./WorkOrderBanner.vue?vue&type=style&index=0&id=5940825b&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5940825b"]])

export default __exports__